import { useState } from "react";

import { Button, DialogActions, Flex, Icon, isNullish, Tooltip } from "@theorgchartdev/storybook";
import { DATA_SOURCES_TEST_PREFIX, GetLastChartValidationTimeLabel } from "./Utils";
import { ValidateDataSourceCreds } from "@/Utils/Promises";
import { appstr } from "@coreapp/utils/appstr";
import { Globals } from "@coreapp/CoreApp/Globals";

export const AuthValidationComposite = props => {
  const [isValidating, setValidating] = useState(false);
  const [lastAuthenticated, setLastAuthenticated] = useState(null);

  const { hover } = GetLastChartValidationTimeLabel(lastAuthenticated);

  let statusIcon = lastAuthenticated ? "circle-check" : "circle-exclamation";
  let colorModifier = lastAuthenticated ? "success" : "danger";

  if (isNullish(lastAuthenticated)) {
    statusIcon = "circle-info";
    colorModifier = "default";
  }

  const handleValidate = async () => {
    let timeStamp = false;
    let validationData = {};
    try {
      setValidating(true);
      const response = await ValidateDataSourceCreds(props.credentials, props.chartConfig?.ID);
      if (response?.timeStamp) {
        timeStamp = response.timeStamp;
      }
      if (response?.validationData) {
        validationData = response?.validationData;
      }
    } catch (e) {
      timeStamp = false;
    } finally {
      setLastAuthenticated(timeStamp);
      setValidating(false);
      Globals._wsMgr.BroadcastTopic("AuthValidation", validationData);
    }
  };

  return (
    <Flex gap="4px" alignItems="center">
      <DialogActions.Secondary
        dataTestId={`${DATA_SOURCES_TEST_PREFIX}-validate-button`}
        loading={isValidating}
        size={"large"}
        onClick={handleValidate}
        disabled={props.disabled}
      >
        {appstr("Validate")}
      </DialogActions.Secondary>
      <Tooltip message={hover}>
        <Icon modifier={colorModifier} name={statusIcon} />
      </Tooltip>
    </Flex>
  );
};
